// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomePage_body__Qcmz0 {
  background-color: #040404;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
}

.HomePage_glassesDemo__-wVsf {
  position: relative;
  width: 100%;
}

`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/HomePage.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".body {\n  background-color: #040404;\n  color: #fff;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.glassesDemo {\n  position: relative;\n  width: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `HomePage_body__Qcmz0`,
	"glassesDemo": `HomePage_glassesDemo__-wVsf`
};
export default ___CSS_LOADER_EXPORT___;
